<div class="grid-container">
  <h1 class="text-center" [innerHTML]="'stancheck.eingabe.start.headline' | translate: welcomePlaceholder"></h1>
  <div class="grid-x grid-padding-x">
    <div class="cell small-12 medium-8 medium-offset-2">
      <p [innerHTML]="'stancheck.eingabe.start.teaser' | translate"></p>
      <div class="callout first" [innerHTML]="'stancheck.eingabe.start.callout1' | translate"></div>
      <div class="callout lighter-gray" [innerHTML]="'stancheck.eingabe.start.callout2' | translate"></div>
    </div>
    <div class="cell medium-offset-2 medium-8">
      <div class="button-wrapper">
        <a [routerLink]="steps?.nextStep? steps.nextStep.path : null" class="button primary inline-arrow-right">{{'stancheck.eingabe.start.next' | translate}}</a>
      </div>
    </div>
  </div>
</div>
